import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {ACTION_TYPES} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {WizardImportSelectionClickEvent} from "../models/events/wizard.import-selection.click-event";

export class WizardImportSelectionsClickEventHandler extends AnalyticsEventHandler {
  analyticsService: AnalyticsService;
  type = ACTION_TYPES.wizardImportSelections;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = WizardImportSelectionClickEvent;
  }

  action(params){
    this.appStore.state.wizardDisplayModel.source = params.source;

    super.action(params)
  }
}
